import type { TableParams } from '@/types/common';

export type CharterStockClassesTableInfo = TableParams & {
  charterFilingId?: string;
};

export interface CharterStockClassesState {
  tableInfo: CharterStockClassesTableInfo;
}

export type CharterStockClassesAction =
  | { type: 'SET_TABLE_INFO'; tableInfo: CharterStockClassesTableInfo }
  | { type: 'PATCH_TABLE_INFO'; patch: Partial<CharterStockClassesTableInfo> }
  | { type: 'SHOW_ACTIVE_FILING' }
  | { type: 'CLEAR_FILING_FILTER' };

export const initialCharterStockClassesTableInfo: CharterStockClassesTableInfo = {
  filter: '',
  sorting: '',
  skipCount: 0,
  maxResultCount: 10,
};

export const initialCharterStockClassesState: CharterStockClassesState = {
  tableInfo: initialCharterStockClassesTableInfo,
};
